import { plural } from './dashboard-flow';

// Linha única do widget Conferência (spec §11): "N conferências por N conferentes, N divergências."
// Conferente com conferência finalizada no período entra na conta; o ranking completo mora em
// /conferencia/ranking.

export interface ConferenceRow {
  total: number;
  divergent: number;
  // Ausentes na API anterior ao histórico de conferências.
  firstTimeRight?: number;
  rechecks?: number;
}

export interface ConferenceSummary {
  conferences: number;
  checkers: number;
  divergences: number;
  /** Conferências sem divergência na primeira vez; null na API anterior ao campo. */
  firstTimeRight?: number | null;
  rechecks?: number | null;
}

export const NO_CONFERENCES = 'Nenhuma conferência finalizada no período.';

export function conferenceSummary(rows: ConferenceRow[] | null | undefined): ConferenceSummary {
  const all = rows ?? [];
  const list = all.filter((r) => r.total > 0);
  const hasHistory = all.some((r) => r.firstTimeRight != null);
  return {
    conferences: list.reduce((sum, r) => sum + r.total, 0),
    checkers: list.length,
    divergences: list.reduce((sum, r) => sum + r.divergent, 0),
    // Reconferência conta mesmo de quem só reconferiu no período (total zero).
    firstTimeRight: hasHistory ? list.reduce((sum, r) => sum + (r.firstTimeRight ?? 0), 0) : null,
    rechecks: hasHistory ? all.reduce((sum, r) => sum + (r.rechecks ?? 0), 0) : null,
  };
}

/**
 * Segunda linha do widget: "Acerto de primeira 97% · 2 reconferências". Null sem conferência no
 * período ou na API anterior ao histórico.
 */
export function conferenceDetailText(s: ConferenceSummary): string | null {
  if (s.conferences === 0 || s.firstTimeRight == null) return null;
  const pct = Math.round((s.firstTimeRight / s.conferences) * 100);
  const parts = [`Acerto de primeira ${pct}%`];
  const rechecks = s.rechecks ?? 0;
  if (rechecks > 0) parts.push(`${rechecks.toLocaleString('pt-BR')} ${plural(rechecks, 'reconferência', 'reconferências')}`);
  return parts.join(' · ');
}

export function conferenceText(s: ConferenceSummary): string {
  if (s.conferences === 0) return NO_CONFERENCES;
  return (
    `${s.conferences.toLocaleString('pt-BR')} ${plural(s.conferences, 'conferência', 'conferências')} ` +
    `por ${s.checkers.toLocaleString('pt-BR')} ${plural(s.checkers, 'conferente', 'conferentes')}, ` +
    `${s.divergences.toLocaleString('pt-BR')} ${plural(s.divergences, 'divergência', 'divergências')}.`
  );
}
